import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

/**
 * Notificações do navegador para mensagens recebidas com a aba sem foco:
 * - contador no título da aba: "(3) PortalServicosOnline" (sempre funciona);
 * - notificação do sistema operacional via Web Notifications API (requer permissão).
 */
@Injectable({
  providedIn: 'root',
})
export class BrowserNotificationService {
  private readonly baseTitle: string;

  constructor(private title: Title) {
    this.baseTitle = this.title.getTitle();
  }

  /** Solicita permissão para notificações do SO (no-op se já decidido ou indisponível). */
  async requestPermission(): Promise<void> {
    if (typeof Notification === 'undefined') {
      return;
    }
    if (Notification.permission === 'default') {
      try {
        await Notification.requestPermission();
      } catch {
        // Ignorado: a UI continua funcionando só com o título da aba.
      }
    }
  }

  /** Atualiza o prefixo "(N)" no título da aba. */
  setUnreadCount(count: number): void {
    this.title.setTitle(count > 0 ? `(${count}) ${this.baseTitle}` : this.baseTitle);
  }

  /** Restaura o título original da aba. */
  clearTitle(): void {
    this.title.setTitle(this.baseTitle);
  }

  /** Dispara uma notificação do SO, se houver permissão. */
  notify(title: string, body: string, tag?: string): void {
    if (typeof Notification === 'undefined' || Notification.permission !== 'granted') {
      return;
    }
    try {
      const notification = new Notification(title, { body, tag, renotify: !!tag } as NotificationOptions);
      notification.onclick = () => {
        window.focus();
        notification.close();
      };
    } catch {
      // Alguns navegadores exigem Service Worker; nesse caso, só o título é usado.
    }
  }
}
